import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Packages
import { Button, Col, Flex, Row, Typography  } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import WorldForm from './WorldForm';
import WorldsOrder from './WorldsOrder';
import WorldsTable from './WorldsTable';

// Actions
import { get_all_worlds } from '../../../redux/actions/worldsActions';
import { get_all_recipes } from '../../../redux/actions/recipesActions';
import { get_all_packages } from '../../../redux/actions/packagesActions';

const Worlds = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [worldToUpdate, setWorldToUpdate] = useState({});
	const [showReorder, setShowReorder] = useState(false);
	const [pageSize, setPageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	useEffect(() => {
		const savedSkip = parseInt(localStorage.getItem('worldsSkip')) || 0;
		setSkip(savedSkip);

		const savedPageSize = parseInt(localStorage.getItem('worldsPageSize')) || 10;
		setPageSize(savedPageSize);

		const filters = { skip: savedSkip, limit: savedPageSize };
		dispatch(get_all_worlds(filters));
		dispatch(get_all_recipes({ skip: 0, limit: 0 }));
		dispatch(get_all_packages({ skip: 0, limit: 0 }));
	}, []);

	const handleAdd = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setWorldToUpdate({});
	}

	const handleReorderOpen = (open) => {
		setShowReorder(open);

		if (open) {
			// the reorder list needs EVERY world, not the current table page
			dispatch(get_all_worlds({ skip: 0, limit: 0 }));
		}
		else {
			dispatch(get_all_worlds({ skip: skip, limit: pageSize }));
		}
	}

	return (
		<div>
			<WorldForm
				messageApi={messageApi}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				update={update}
				worldToUpdate={worldToUpdate}
				setWorldToUpdate={setWorldToUpdate}
				pageSize={pageSize}
				skip={skip}
			/>

			<WorldsOrder
				messageApi={messageApi}
				isModalOpen={showReorder}
				setIsModalOpen={handleReorderOpen}
			/>

			<Row>
				<Col xs={24} sm={18} md={18} lg={18} xl={18}>
					<Typography.Title>{t('menuItems.game.worlds')}</Typography.Title>
				</Col>
				<Col xs={24} sm={6} md={6} lg={6} xl={6}>
					<Flex align='center' justify='flex-end' gap={10} style={{ height: '100%' }}>
						<Button
							size='large'
							onClick={() => handleReorderOpen(true)}
						>
							{t('buttons.reorder')}
						</Button>
						<Button
							type='primary'
							size='large'
							onClick={handleAdd}
						>
							{t('buttons.create')}
						</Button>
					</Flex>
				</Col>
			</Row>

			<WorldsTable
				messageApi={messageApi}
				pageSize={pageSize}
				setPageSize={setPageSize}
				skip={skip}
				setSkip={setSkip}
			/>
		</div>
	)
}

Worlds.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Worlds;
